import React from 'react';
import {or_maybes} from './list';
import OrMaybesList from './OrMaybesList';

export default function AllOrMaybes(props) {
  return <div className="all-or-maybes">
    <OrMaybesList list={or_maybes} />
  </div>;
};
